import { MijnRoute } from '../mijn-navigatie.model';

export const CONTACT: MijnRoute = {
    path: 'contact',
    navigationEvent: 'toContact',
    regex: /^\/contact$/,
    webcomponent: 'mijn-contact-webcomponent'
};
